export interface LoginRequest {
  email: string;
  password: string;
  deviceId: any;
  verificationId?: string;
  twoFactorAuthToken?: string;
}

export enum LoginFormIds {
  PASSWORD = 'password',
  EMAIL = 'email',
}
